// extracted by mini-css-extract-plugin
module.exports = {"casopisi":"Magazines_casopisi__1JJUe","casopisiTab":"Magazines_casopisiTab__2ysr3","italic":"Magazines_italic__1BFZX"};